import { useMemo } from "react";
import { PropTypes } from "prop-types";

import studentDisplayName from "../../utils/studentDisplayName";
import T from "../translations/Translations";

/**
 *
 * @param {*} param0
 * @returns
 */
const SemesterComments = ({ selectedEpr, selectedSubject }) => {
    const { studentName } = selectedEpr || {};

    const subjectToAll = T({ key: "Subject_To_All" });
    const comment = T({ key: "Subject_Comment" });

    const mergedSubject = useMemo(() => {
        const { gradingCriteriaDtos } = selectedEpr;
        // Filter the raw data first by subject, then merge
        const filteredData = gradingCriteriaDtos?.filter((criteria) => criteria.subjectName === selectedSubject);
        if (filteredData.length === 0) {
            return {
                gradingCriteriaComment: "",
                contentStudentComment: ""
            };
        }
        const { gradingCriteriaComment, contentStudentComment } = filteredData[0];
        return {
            gradingCriteriaComment,
            contentStudentComment
        };
    }, [selectedEpr, selectedSubject]);

    if (!mergedSubject.gradingCriteriaComment && !mergedSubject.contentStudentComment) {
        return null;
    }

    return (
        <div className="subject-container">
            <div className="subject-title">{selectedSubject} Comments</div>
            <div className="subject-message">
                {mergedSubject.gradingCriteriaComment && (
                    <div className="message-container">
                        <div className="message-container-title">
                            {subjectToAll} {selectedSubject}
                        </div>
                        <div className="message-container-body">{mergedSubject.gradingCriteriaComment}</div>
                    </div>
                )}
                {mergedSubject.contentStudentComment && (
                    <div className="message-container">
                        <div className="message-container-title">
                            {studentDisplayName(studentName)}&apos;s {selectedSubject} {comment}
                        </div>
                        <div className="message-container-body">{mergedSubject.contentStudentComment}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

SemesterComments.propTypes = {
    selectedEpr: PropTypes.object,
    selectedSubject: PropTypes.string
};

SemesterComments.defaultProps = {
    selectedEpr: {},
    selectedSubject: ""
};

export default SemesterComments;
